import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import checkCircle from 'src/assets/icons/filled-icons/check-circle.svg';

import { QUOTE_STEPS } from './createQuote.const';
import { IStepNew } from './createQuote.interface';
import { completedSteps as completedStepsSelector, setCreateQuoteStep } from './CreateQuote.slice';

const Sidebar: FC<{
    currentStep: IStepNew;
    classification?: string;
}> = ({ currentStep, classification }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const completedSteps = useSelector(completedStepsSelector);

    const handleStepClick = (step: IStepNew) => () => {
        dispatch(setCreateQuoteStep(step.key));
    };

    return (
        <>
            <ul className="stepper-sidebar-wrap space-y-1">
                {QUOTE_STEPS(t, classification).map((step, index) => {
                    const isActive = currentStep.step === step.step && true;
                    const Icon = step.icon;

                    return (
                        <li
                            key={index}
                            className={`vertical-secondary-tab-item ${isActive && 'vertical-secondary-tab-item-active'} ${!isActive ? 'cursor-pointer' : ''}`}
                            onClick={handleStepClick(step)}
                            style={{
                                cursor: !isActive ? 'pointer' : 'default',
                            }}
                        >
                            <div className={`vertical-secondary-tab-item-icon-wrap`}>
                                <Icon className="vertical-secondary-tab-item-icon" />
                            </div>

                            {/* Content */}

                            <h3 className={`vertical-secondary-tab-item-title`}>{step.title}</h3>

                            {completedSteps.includes(step.key) && (
                                <div>
                                    <img src={checkCircle} alt="check" className="vertical-secondary-tab-item-status-icon" />
                                </div>
                            )}
                        </li>
                    );
                })}
            </ul>
        </>
    );
};

export default Sidebar;
